import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useDeleteUser } from '@/hooks/useUser';
import Button from '@/components/common/Button';
import Modal from '@/components/common/Modal';

export default function AccountSettings() {
  const { signOut } = useAuth();
  const deleteUser = useDeleteUser();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleDelete = async () => {
    try {
      await deleteUser.mutateAsync();
      await signOut();
    } catch {
      // Error handled by mutation
    }
  };

  return (
    <section className="space-y-4">
      <h2 className="text-lg font-semibold text-neutral-900">Account</h2>

      <div className="rounded-lg border border-error-200 bg-error-50 p-4">
        <h3 className="text-sm font-semibold text-error-700">Danger Zone</h3>
        <p className="mt-1 text-sm text-error-600">
          Deleting your account will permanently remove all your data, including messages, moves,
          and settings. This action cannot be undone.
        </p>
        <Button
          variant="danger"
          size="sm"
          className="mt-3"
          onClick={() => setShowDeleteModal(true)}
        >
          Delete Account
        </Button>
      </div>

      <Modal
        isOpen={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setConfirmText('');
        }}
        title="Delete Account"
        size="sm"
      >
        <p className="mb-4 text-sm text-neutral-600">
          This will permanently delete your account and all associated data. Type{' '}
          <strong>DELETE</strong> to confirm.
        </p>
        <input
          type="text"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="Type DELETE to confirm"
          className="mb-4 w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm text-neutral-100 placeholder:text-neutral-500 focus:border-error-500 focus:outline-none focus:ring-2 focus:ring-error-500"
        />
        <div className="flex justify-end gap-3">
          <Button
            variant="secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setConfirmText('');
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            disabled={confirmText !== 'DELETE'}
            loading={deleteUser.isPending}
          >
            Delete Account
          </Button>
        </div>
      </Modal>
    </section>
  );
}
